import React, { useMemo, ReactElement } from "react";
import { Divider, MenuItem, Popover } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
import { StyledMenuProps } from "models/propTypes/menuPropTypes";
import { IconDefinitionConstants } from "utils/constants";
import CommonMenuItem from "./commonMenuItem";

const StyledMenu: React.FC<StyledMenuProps> = (props) => {
  const onClickItem = (id: number) => {
    props.onMenuClickHandler && props.onMenuClickHandler(id);
    props.closeMenu();
  };

  const items = useMemo(() => {
    const title: ReactElement[] = [];
    let list: ReactElement[] = [];
    let actions: ReactElement[] = [];

    const hasActions = props.actionList && props.actionList?.length > 0;
    const hasItems = props.itemList && props.itemList.length > 0;

    if (hasItems) {
      props.title &&
        title.push(
          <MenuItem className={cssExports.menuTitle} key={"menu-title"}>
            {props.title}
          </MenuItem>
        );

      list =
        props.itemList?.map((item, index) => (
          <CommonMenuItem
            onClick={onClickItem.bind(null, item.id)}
            key={`menu-item-${index}`}
            selected={item.selected}
            text={item.text}
            icon={item.selected ? IconDefinitionConstants.WCheck : undefined}
          />
        )) ?? [];
    }

    if (hasActions)
      actions =
        props.actionList?.map((item, index) => (
          <CommonMenuItem
            onClick={item.onClickHandler}
            key={`menu-action-${index}`}
            text={item.text}
            icon={item.icon}
            disabled={item.disabled}
          />
        )) ?? [];

    return title
      .concat(
        <div key={"menu-item-list"} className={cssExports.listItemContainer}>
          {list}
        </div>
      )
      .concat(hasItems && hasActions ? [<Divider key={"menu-divider"}></Divider>] : [])
      .concat(actions);
  }, [props.itemList, props.actionList]);

  return (
    <Popover
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id="customized-menu"
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={props.closeMenu}
      className={cssExports.menuPopover}
      classes={{ paper: cssExports.menuContainer }}
    >
      {items}
    </Popover>
  );
};

export default StyledMenu;
